const RETURN_URL_LOGIN = 'RETURN_URL_LOGIN';
const RETURN_URL_REGISTER = 'RETURN_URL_REGISTER';
const RETURN_URL_ACTIVATE = 'RETURN_URL_ACTIVATE';

export { RETURN_URL_LOGIN, RETURN_URL_REGISTER, RETURN_URL_ACTIVATE };
